export default __webpack_public_path__ + "static/media/provider-banner.d745b9eb.png";